import { render, staticRenderFns } from "./BrandConfusionTip.vue?vue&type=template&id=0383cfc4&scoped=true"
import script from "./BrandConfusionTip.vue?vue&type=script&lang=js"
export * from "./BrandConfusionTip.vue?vue&type=script&lang=js"
import style0 from "./BrandConfusionTip.vue?vue&type=style&index=0&id=0383cfc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0383cfc4",
  null
  
)

export default component.exports